import { useFetchCallback } from '@services/services';
import { Integration } from '@utils/constants';
import toast from 'react-hot-toast';

export const useSyncIntegration = () => {
  const { call, isFetching } = useFetchCallback<Record<string, unknown>, Record<string, unknown>>(
    'post',
    '/v1/integrations/sync',
  );

  const syncIntegration = async (
    integration: Integration,
    options: {
      queryParams?: Record<string, string>;
      [key: string]: unknown;
    } = {},
  ): Promise<Record<string, unknown>> => {
    try {
      const { queryParams, notify = true, ...payload } = options;

      // Build query string for partial sync (e.g., "?resource=payment_types")
      const queryString = queryParams ? '?' + new URLSearchParams(queryParams).toString() : undefined;

      const response = await call({
        path: queryString,
        data: {
          provider_type: integration.provider_type,
          provider_code: integration.provider_code,
          ...payload,
        },
      });

      if (notify) toast.success('Servicio sincronizado');
      return response as Record<string, unknown>;
    } catch (error) {
      toast.error('Error al conocer el servicio');
      throw error;
    }
  };

  return { syncIntegration, isFetching };
};
